import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import styled from 'styled-components';
import SectionTitle from './SectionTitle';

// const faqs = [
//   {
//     question: 'What is Nutrify Today’s Supply Chain portal ?',
//     answer: (<>
//       <p>Supply Chain platform designed specifically for the Nutraceutical Industries, bridging the gap between buyers and sellers. Connect with potential buyers or suppliers, enhance your market presence, and drive growth.</p>
//       <h6 className='mt-4 mb-3 text-dark'>Key Highlights:</h6>
//       <ul className='ps-4'>
//         <li><span className='fw-medium text-dark'> Transparent Interface: </span> Easy to use and completely transparent interactions.</li>
//         <li><span className='fw-medium text-dark'> Exclusive for Nutraceuticals: </span> Tailored to meet industry-specific needs.</li>
//         <li><span className='fw-medium text-dark'> Absolutely Free: </span> Join without any charges and start connecting.</li>
//         <li><span className='fw-medium text-dark'> Business Opportunities: </span> Increase visibility and generate orders from markets.</li>
//       </ul>
//     </>),
//   },
//   {
//     question: 'What the documents required for registering a Company?',
//     answer: (
//       <p>PAN and GST are mandatory documents for registration of a Company.</p>
//     ),
//   },
//   {
//     question: 'What should be the Image Size for uploading Company Images & Logos and what formats does the platform support?',
//     answer: (
//       <>
//         <ul>
//           <li><span className="fw-medium text-dark">Image Size:</span> Less than 5 MB.</li>
//           <li><span className="fw-medium text-dark">Supported Formats:</span> JPG/JPEG</li>
//         </ul>
//         <p><span className='fw-medium text-dark'>Suggestion:</span> Try uploading rectangle images for Company images. If compnay images not available put company logo in company images but make sure that logo image size in rectangle shaper otherwise, logo won't be visible properly in rectable shape image.</p>
//       </>
//     ),
//   }
// ];
const faqs = [
  {
    question: 'What is the NT Supply Chain platform?',
    answer: (
      <>
        <p>
          The Nutrify Today (NT) Supply Chain is a specialized B2B marketplace focused
          exclusively on the Nutraceutical, Functional Food, and Dietary Supplement
          industries. It connects qualified buyers (brands, formulators) with verified
          suppliers (ingredient manufacturers, contract manufacturers, distributors)
          globally.
        </p>
        <p>
          Our mission is to streamline sourcing by emphasizing quality, compliance, and
          industry-specific expertise.
        </p>
      </>
    ),
  },
  {
    question:
      'How is NT Supply Chain different from large horizontal marketplaces like IndiaMART?',
    answer: (
      <>
        <p>NT Supply Chain offers deeper specialization compared to broad platforms.</p>
        <ul className="ps-4">
          <li>
            <span className="fw-medium text-dark">Niche Focus:</span> Only nutraceuticals
            and ingredients — every supplier and product is industry-relevant.
          </li>
          <li>
            <span className="fw-medium text-dark">Quality First:</span> Compliance-focused
            features such as GMP, FSSAI, ISO 22000, Halal/Kosher verification.
          </li>
          <li>
            <span className="fw-medium text-dark">Curated Leads:</span> RFQs matched based
            on ingredient technical specifications, ensuring high-quality business
            inquiries.
          </li>
        </ul>
      </>
    ),
  },
  {
    question: 'How do you verify the quality and compliance of suppliers?',
    answer: (
      <>
        <p>
          We encourage suppliers to obtain Niche Verification through our platform. This
          includes:
        </p>
        <ul className="ps-4">
          <li>Displaying mandatory details like GST and Company Type.</li>
          <li>
            Uploading digital compliance certificates (GMP, FSSAI, ISO 22000,
            Halal/Kosher).
          </li>
          <li>
            Using our Documentation & CoA Hub to securely share technical documents,
            product data sheets, and Certificates of Analysis (CoA).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: 'What is the Compliance Badge and why is it important?',
    answer: (
      <>
        <p>
          The Compliance Badge is a visual indicator on a supplier's profile that confirms
          their adherence to critical industry standards such as GMP or regulatory
          certifications.
        </p>
        <p>
          It acts as a trust signal for buyers and simplifies the due diligence process,
          helping them quickly identify credible and compliant suppliers.
        </p>
      </>
    ),
  },
  {
    question: 'Is there a fee for buyers to use the NT Supply Chain platform?',
    answer: (
      <p>
        No, buyers can access the platform for free. You can search products, browse
        supplier profiles, and post RFQs at no cost. Optional services, like third-party
        audits, may require an additional fee.
      </p>
    ),
  },
  {
    question: 'How do I request a quote or connect with a specific supplier?',
    answer: (
      <>
        <p>You can connect with suppliers in two ways:</p>
        <ul className="ps-4">
          <li>
            <span className="fw-medium text-dark">Direct Inquiry:</span> Contact suppliers
            directly from their product listing or profile.
          </li>
          <li>
            <span className="fw-medium text-dark">Structured RFQ:</span> Post detailed
            requirements (e.g., “Need 500kg of 95% Curcumin extract, solvent-free”), and
            the system will auto-match you with relevant suppliers.
          </li>
        </ul>
      </>
    ),
  },
  {
    question: 'How do I list my products and services on the NT Supply Chain?',
    answer: (
      <>
        <p>
          Suppliers can register their company and create product listings through the
          Supplier Onboarding process.
        </p>
        <p>
          Detailed technical product information is required to ensure accurate matching
          with buyer needs.
        </p>
      </>
    ),
  },
  {
    question: 'What are the benefits of a Paid Subscription on NT Supply Chain?',
    answer: (
      <>
        <p>Paid subscriptions provide several advantages:</p>
        <ul className="ps-4">
          <li>Higher visibility in product categories and search results.</li>
          <li>Access to more high-quality RFQs from verified buyers.</li>
          <li>Option to display Compliance/Niche Verification Badges.</li>
          <li>
            Priority access to market data and ingredient demand insights.</li>
        </ul>
      </>
    ),
  },
  {
    question: 'Does NT Supply Chain facilitate secure transactions?',
    answer: (
      <>
        <p>
          Yes. A secure Payment Gateway (Escrow service) is provided as an optional
          feature.
        </p>
        <p>
          Buyer funds are held securely until they confirm successful receipt and
          inspection of materials—ensuring safe, reliable B2B transactions.
        </p>
      </>
    ),
  },
];

export default function FAQSection() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (index) => (event, isExpanded) => {
    setExpanded(isExpanded ? index : false);
  };

  return (
    <Wrapper>
      <div className="faq-wrapper">
        <h4 className="faq-subtitle">You ask? We answer </h4>
        <SectionTitle title="Frequently Ask Question" />

        <Box className="faq-container">
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === index}
              onChange={handleChange(index)}
              className="faq-accordion"
            >
              <AccordionSummary
                className='py-2'
                expandIcon={
                  expanded === index ? (
                    <RemoveIcon className="faq-icon" />
                  ) : (
                    <AddIcon className="faq-icon" />
                  )
                }
              >
                <h4 className="faq-question">{faq.question}</h4>
              </AccordionSummary>
              <AccordionDetails>
                <div className="faq-answer">{faq.answer}</div>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
.faq-wrapper {
  text-align: center;
  padding: 80px 20px;
  background: linear-gradient(to bottom right, #f9fafb, #ffffff);
}

.faq-subtitle {
  text-transform: uppercase;
  color: #ff7b00;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.05em;
}

.faq-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 10px 0 40px 0;
}

.faq-title span {
  font-style: italic;
  font-weight: 500;
  color: #666;
}

.faq-container {
  max-width: 850px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.faq-accordion {
  box-shadow: none !important;
  border: none !important;
  margin: 0;
  border-bottom: 1px solid #eee !important;
  padding: 0 40px;
}

.faq-accordion:last-child {
  border-bottom: none !important; 
}

.faq-question {
  font-weight: 400;
  font-size: 1.05rem;
  text-align: left;
  line-height: 1.8rem;
  width: 90%;
  color: black;
}

.faq-answer {
  text-align: left;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
}

.faq-icon {
  color: #000;
  font-size: 1.4rem;
}
`